import React from 'react';
import { Card, CardContent, Typography } from '@material-ui/core';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { SimovsatDeviceActivity } from '~/types';

interface ActiveInactiveCardProps {
  deviceActivity: SimovsatDeviceActivity;
}

const COLORS = {
  ligado: '#4CAF50',
  desligado: '#F44336',
};

export default function ActiveInactiveCard({ deviceActivity }: ActiveInactiveCardProps) {
  const data = [
    { name: deviceActivity.desligado.label, value: deviceActivity.desligado.percent },
    { name: deviceActivity.ligado.label, value: deviceActivity.ligado.percent },
  ];

  const renderCustomLabel = (entry: any) => `${entry.value.toFixed(1)}%`;

  return (
    <Card style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardContent style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', padding: 20 }}>
        <Typography variant='h6' style={{ fontWeight: 'bold', marginBottom: 20, textAlign: 'center' }}>
          ATIVO/INATIVO
        </Typography>
        <ResponsiveContainer width='100%' height={300}>
          <PieChart>
            <Pie
              data={data}
              cx='50%'
              cy='50%'
              innerRadius={60}
              outerRadius={100}
              paddingAngle={5}
              dataKey='value'
              label={renderCustomLabel}
            >
              {data.map((_, index) => (
                <Cell key={`cell-${index}`} fill={index === 0 ? COLORS.desligado : COLORS.ligado} />
              ))}
            </Pie>
            <Tooltip formatter={(value: number, name: string) => [`${value.toFixed(1)}%`, name]} />
            <Legend
              verticalAlign='bottom'
              height={36}
              formatter={(value, entry: any) => <span style={{ color: entry.color }}>{value}</span>}
            />
          </PieChart>
        </ResponsiveContainer>
        <div style={{ display: 'flex', gap: 20, marginTop: 10 }}>
          <Typography variant='body2' style={{ color: COLORS.desligado, fontWeight: 'bold' }}>
            Desligado: {deviceActivity.desligado.percent.toFixed(1)}%
          </Typography>
          <Typography variant='body2' style={{ color: COLORS.ligado, fontWeight: 'bold' }}>
            Ligado: {deviceActivity.ligado.percent.toFixed(1)}%
          </Typography>
        </div>
      </CardContent>
    </Card>
  );
}
